import { rateLimitingEnabled } from '@/utils';
import QuestionsUIV2Mixin from '@/mixins/questions-ui-v2';

export default {
  mixins: [QuestionsUIV2Mixin],
  computed: {
    currentSession() {
      return this.$store.getters['flashcards/currentSession'];
    },
    defaultCustomQuizImageAttachmentId() {
      return this.$store.getters['app/defaultCustomQuizImageAttachmentId'];
    },
    defaultCustomQuizImageAttachment() {
      return this.$store.getters['attachments/get'][this.defaultCustomQuizImageAttachmentId];
    },
    defaultImageIcon() {
      return this.defaultCustomQuizImageAttachment?.url || '';
    },
    firstUnansweredFlashcardId() {
      const currentCategoryId = Number(this.$route.params.categoryId);
      const flashcardStateList = this.$store.getters['flashcardStates/flashcardStateList'];
      const answeredFlashcardIds = flashcardStateList
        .filter(state => state.categoryId === currentCategoryId)
        .map(state => state.flashcardId);

      const firstUnansweredFlashcardId = this.currentSession.reduce((id, flashcardId) => {
        if (id) return id;
        if (answeredFlashcardIds.includes(flashcardId)) return id;
        return flashcardId;
      }, null);
      return firstUnansweredFlashcardId;
    },
    flashcardRoute() {
      return `${this.routePrefix}#flashcard${this.questionUiV2Enabled ? '-v2' : ''}`;
    },
    routePrefix() {
      return (this.$route.name.includes('scenario')) ? 'scenarios' : 'quizzes';
    },
  },
  watch: {
    defaultCustomQuizImageAttachmentId() {
      this.fetchDefaultImage();
    },
  },
  mounted() {
    this.fetchDefaultImage();
  },
  methods: {
    fetchDefaultImage() {
      if (this.defaultCustomQuizImageAttachmentId) {
        this.$store.dispatch('attachments/fetch', { ids: [this.defaultCustomQuizImageAttachmentId] });
      }
    },
    restartQuiz(category, query = null) {
      this.$analytics.events.restartedQuiz(this.$store, category);
      this.$store.dispatch('quizzes/resetQuiz', category.id).then(() => {
        this.$router.push({ name: `${this.flashcardRoute}`, params: { categoryId: category.id }, query: query || this.currentQuery });
      });
    },
    startQuiz(category, query = null) {
      this.$analytics.events.startedQuiz(this.$store, category);
      let params = {
        number: 0,
        categoryStatusId: this.$store.getters['categoryStatuses/inProgressStatus'].id,
        categoryId: category.id,
        mobileCreatedAt: Date.now(),
        rateLimited: rateLimitingEnabled({
          apptimize: this.$apptimize,
          store: this.$store,
          analytics: this.$analytics,
        }),
      };

      this.$store.dispatch('categoryStates/sendCategoryState', params);
      this.$router.push({ name: `${this.flashcardRoute}`, params: { categoryId: category.id }, query: query || this.currentQuery });
    },
    continueQuiz(category, query = null) {
      this.$analytics.events.continuedQuiz(this.$store, category);
      this.$router.push({ name: `${this.flashcardRoute}`, params: { categoryId: category.id }, query: query || this.currentQuery });
    },
    completeQuiz(categoryId, number = 0) {
      const params = {
        number,
        categoryStatusId: this.$store.getters['categoryStatuses/completedStatus'].id,
        categoryId,
        mobileCreatedAt: Date.now(),
        rateLimited: rateLimitingEnabled({
          apptimize: this.$apptimize,
          store: this.$store,
          analytics: this.$analytics,
        }),
      };
      return this.$store.dispatch('categoryStates/sendCategoryState', params);
    },
    quizStatus(category) {
      let state = this.$store.getters['categoryStates/categoryStates'][category.id] || {categoryStatusId: this.$store.getters['categoryStatuses/notStartedStatus'].id};
      return this.$store.getters['categoryStatuses/categoryStatuses'].find(cs => cs.id == state.categoryStatusId);
    },
    deleteQuiz(category) {
      if (confirm('Are you sure you want to delete this quiz? This action cannot be undone.')) {
        this.$store.dispatch('quizzes/deleteQuiz', category.id).then(() => {
          this.$notify({
            group: 'notifications',
            title: 'Quiz Deleted',
            text: 'The quiz has been deleted successfully.',
            type: 'success',
          });
        }).catch(error => {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'Failed to delete the quiz. Please try again.',
            type: 'error',
          });
        });
      }
    },
  },
};
